import { render, staticRenderFns } from "./ImpressionistModule.vue?vue&type=template&id=134e3f40&"
import script from "./ImpressionistModule.vue?vue&type=script&lang=ts&"
export * from "./ImpressionistModule.vue?vue&type=script&lang=ts&"
import style0 from "./ImpressionistModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports